import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { Loader2, Lock, Check } from "lucide-react";
import { api, formatErr } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export default function SubscribeButton({ creator, testId = "creator-subscribe-btn", compact = false, className = "" }) {
  const { user } = useAuth();
  const nav = useNavigate();
  const [loading, setLoading] = useState(false);

  if (!creator?.is_creator || (user && user.id === creator.id)) return null;

  if (creator.is_subscribed) {
    return (
      <span data-testid={`${testId}-subscribed`}
        className={`inline-flex items-center justify-center gap-1.5 rounded-sm border border-[#2A2E37] bg-[#1C1F26] px-4 py-2 text-sm font-semibold text-gray-200 ${className}`}>
        <Check className="h-4 w-4" /> Subscribed
      </span>
    );
  }

  const go = async (e) => {
    e?.stopPropagation();
    if (!user) return nav("/login");
    setLoading(true);
    try {
      const { data } = await api.post("/payments/checkout", { creator_id: creator.id, origin_url: window.location.origin });
      localStorage.setItem("velvet_pending_creator", creator.username);
      window.location.href = data.checkout_url;
    } catch (err) {
      toast.error(formatErr(err));
      setLoading(false);
    }
  };

  return (
    <button onClick={go} disabled={loading} data-testid={testId}
      className={`btn-neon inline-flex items-center justify-center gap-2 rounded-sm px-5 py-2.5 text-sm font-semibold text-white disabled:opacity-70 ${className}`}>
      {loading ? <Loader2 className="h-4 w-4 animate-spin" /> : <Lock className="h-4 w-4" />}
      {compact ? `$${creator.price}/mo` : `Subscribe · $${creator.price}/mo`}
    </button>
  );
}
